import { Directive } from '@angular/core';
import { RouterLink, ActivatedRoute } from '@angular/router';

/**
 * This Directive will add automatically for each routerLink found in the template, the basisideeID as querystring parameter
 *
 * @export
 * @class WorkflowRouteDirective
 */
@Directive({
  selector: 'a[routerLink]',
})
export class WorkflowRouteDirective {
  constructor(private link: RouterLink, private route: ActivatedRoute) {
    this.route.queryParamMap.subscribe(() => {
      if (this.route.snapshot.queryParams.bid) {
        if (!this.link.queryParams) {
          this.link.queryParams = {};
        }
        this.link.queryParams.bid = this.route.snapshot.queryParams.bid;
      }
    });
  }
}
